<template>
  <div class="marketing-table-container">
    <div class="marketing-table-filters">
      <form class="form-inline" @submit.prevent="filterChanged">
        <div class="row">
          <div class="col-xs-12 col-sm-6 col-left">
            <div class="form-group">
              <date-picker
                v-if="false"
                type="year"
                valueType="format"
                format="YYYY"
                :range="true"
                v-model="params.years"
                placeholder="Year range"
              ></date-picker>
            </div>
          </div>
          <div class="col-xs-12 col-sm-6 col-right">
            <div class="form-group">
              <div class="radio-inline" v-for="option of filters.type.options">
                <label
                  ><input type="radio" :value="option" v-model="params.type" /> {{ option }}</label
                >
              </div>
            </div>
          </div>
        </div>
      </form>
    </div>

    <div class="marketing-table-results">
      <div class="row">
        <div class="col-xs-12">
          <vuetable
            ref="vuetable"
            :css="vuetableCss.table"
            :fields="fields"
            :api-mode="false"
            :perPage="perPage"
            :scrollVisible="false"
            :data-manager="dataManager"
            :sort-order="sortOrder"
            pagination-path="pagination"
            @vuetable:pagination-data="onPaginationData"
          ></vuetable>
        </div>
      </div>
      <div class="row">
        <div class="col-sm-4 col-md-5" style="padding-top: 8px;">
          Showing {{ from + 1 }} to {{ to }} of {{ total }} entries
        </div>
        <div class="col-sm-8 col-md-7 text-right">
          <vuetable-pagination
            ref="pagination"
            :css="vuetableCss.pagination"
            @vuetable-pagination:change-page="onChangePage"
          ></vuetable-pagination>
        </div>
      </div>
    </div>
    <div class="marketing-table-footer"></div>
  </div>
</template>

<script>
import { Vuetable } from 'vue3-vuetable';
import VuetablePagination from './VuetablePagination';
import { VUETABLE_CSS } from "~/constants/global";
import DatePicker from 'vue-datepicker-next';

export default {
  name: 'NbaPlayersHeight',
  components: {
    Vuetable,
    VuetablePagination,
    DatePicker,
  },
  data() {
    return {
      filters: window['nba_players_filters'],
      params: {
        type: window['nba_players_filters']['type']['options'][0],
        years: ['1947', '' + new Date().getFullYear()],
      },
      db: window['nba_players_db'],
      perPage: 10,
      total: 0,
      from: 0,
      to: 0,
      fields: [
        {
          name: 'year',
          sortField: 'year',
          title: 'Season',
        },
        {
          name: 'name',
          sortField: 'name',
          title: 'Name',
        },
        {
          name: 'height_inch',
          sortField: 'height_inch',
          title: 'Height',
          formatter: value => value,
        },
      ],
      sortOrder: [
        {
          field: 'year',
          direction: 'asc',
        },
      ],
      vuetableCss: VUETABLE_CSS,
    };
  },
  created() {
    this.db = this.getFilteredDb();
  },
  watch: {
    'params.years': function(value, oldValue) {
      this.filterChanged();
    },
    'params.type': function(value, oldValue) {
      this.filterChanged();
    },
  },
  methods: {
    filterChanged() {
      this.db = this.getFilteredDb();
      this.$refs.vuetable.refresh();
    },
    getFilteredDb() {
      return window['nba_players_db'].filter(row => {
        if (this.params.years) {
          if (this.params.years[0] && row.year < this.params.years[0]) {
            return false;
          }

          if (this.params.years[1] && row.year > this.params.years[1]) {
            return false;
          }
        }

        if (this.params.type && row.type !== this.params.type) {
          return false;
        }

        return true;
      });
    },
    onPaginationData(paginationData) {
      this.$refs.pagination.setPaginationData(paginationData);
    },
    onChangePage(page) {
      this.$refs.vuetable.changePage(page);
    },
    dataManager(sortOrder, pagination) {
      let data = this.db;

      if (data.length < 1) return;

      if (sortOrder.length > 0) {
        data.sort((a, b) => {
          let aVal = a[sortOrder[0].sortField];
          let bVal = b[sortOrder[0].sortField];

          if (sortOrder[0].direction === 'desc') {
            if (aVal > bVal) {
              return -1;
            }

            if (aVal < bVal) {
              return 1;
            }
          } else {
            if (aVal < bVal) {
              return -1;
            }

            if (aVal > bVal) {
              return 1;
            }
          }

          return 0;
        });
      }

      pagination = this.$refs.vuetable.makePagination(data.length, this.perPage);

      this.$refs.pagination.setPaginationData(pagination);

      this.from = pagination.from - 1;
      this.to = this.from + this.perPage;
      this.total = data.length;

      return {
        pagination: pagination,
        data: data.slice(this.from, this.to),
      };
    },
  },
};
</script>

<style lang="scss">
//@import 'vue-datepicker-next/scss/index.scss';
@import 'vue-datepicker-next/index.css';

.marketing-table-container {

}
</style>
